import {createFileRoute} from '@tanstack/react-router';
import {DepositApplicationResultAccountPage} from 'features/deposit/onboarding/pages/DepositApplicationResultAccountPage';

export const Route = createFileRoute(
  '/_protected/deposit-onboarding/$applicationId/$productCode/deposit-account',
)({
  component: DepositApplicationResultAccountPage,
});
